import * as React from "react";
import { APINames } from "../../../../legacy/api/api.names";
import { BetButton } from "../../../../v2/components/BetButton";
import { BalanceDisplayDesktopDefault } from "../../../../v2/components/Display/desktop/Balance";
import { BetDisplayDesktopDefault } from "../../../../v2/components/Display/desktop/Bet";
import { FreeRoundsDisplayDesktopDefault } from "../../../../v2/components/Display/desktop/FreeRounds";
import { TotalWinDisplayDesktopDefault } from "../../../../v2/components/Display/desktop/TotalWin";
import { WinDisplayDesktopDefault } from "../../../../v2/components/Display/desktop/Win";
import { PaytableButton } from "../../../../v2/components/PaytableButton";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";

import {
  SpinControlKeypadButton,
  StyledCombinedSpinButton,
  StyledKeypadButton
} from "./components/Buttons";
import { SoundButton } from "./components/SoundButton/SoundButton.container";
import { KeypadWrapper } from "./components/Wrappers.Default";
import { IKeypadDesktop } from "./KeypadDesktop";
import { View } from "../../../../api/api";
export const KeypadDesktopDefaultView = ({
  hidden,
  allowAutoplayStart,
  autoplayAvailable,
  autoplayRoundsSelected,
  autoplayRoundsLeft,
  autoplayRunning,
  autoplayButtonDisabled,
  isFreeRoundsEnabled,
  spinStarted,
  menuButtonDisabled,
  spinButtonDisabled,
  quickSpinEnabled,
  quickSpinAvailable,
  quickSpinActive,
  triggerQuickSpinChangeRequest,
  triggerDefaultViewChangeRequest,
  triggerAutoplaySettingsViewChangeRequest,
  triggerGameRulesViewChangeRequest,
  view
}: IKeypadDesktop) => {
  const isSettingsMenuViewActive =
    view === View.MAIN_SETTINGS ||
    view === View.GAME_RULES ||
    view === View.GAME_HISTORY;
  const isAutoplaySettingsViewActive = view === View.AUTOPLAY_SETTINGS;

  const autoplayActive =
    allowAutoplayStart &&
    (autoplayRoundsSelected > 0 || autoplayRoundsLeft > 0);

  const onlyAutoplay: boolean = autoplayAvailable && !quickSpinAvailable;
  const onlyQuickspin: boolean = !autoplayAvailable && quickSpinAvailable;
  const showButterfly: boolean = autoplayAvailable && quickSpinAvailable;

  const MenuButton = (
    <StyledKeypadButton
      apiName={APINames.MENU_BUTTON}
      data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_MENU_BUTTON}
      type="menu"
      onClick={
        !menuButtonDisabled &&
        (isSettingsMenuViewActive
          ? triggerDefaultViewChangeRequest
          : triggerGameRulesViewChangeRequest)
      }
      disabled={menuButtonDisabled}
    />
  );
  const AutoplayButton = (
    <SpinControlKeypadButton
      data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_AUTOPLAY_BUTTON}
      apiName={APINames.AUTOPLAY_BUTTON}
      type={"autoplay"}
      onClick={
        !autoplayButtonDisabled &&
        (isAutoplaySettingsViewActive
          ? triggerDefaultViewChangeRequest
          : triggerAutoplaySettingsViewChangeRequest)
      }
      disabled={autoplayButtonDisabled}
    />
  );

  const SpinButton = (
    <StyledCombinedSpinButton
      disabled={spinButtonDisabled}
      autoplayEnabled={isAutoplaySettingsViewActive}
      autoplayActive={autoplayActive}
      autoplayRoundsLeft={autoplayRoundsLeft}
      autoplayRunning={autoplayRunning}
      spinStarted={spinStarted}
      data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_SPIN_BUTTON}
    />
  );

  const QuickSpinButton = (
    <SpinControlKeypadButton
      apiName={APINames.QUICKSPIN_BUTTON}
      data-e2e-id={E2EIdentifier.DEFAULT_KEYPAD_QUICK_SPIN_BUTTON}
      type="quickspin"
      onClick={
        quickSpinEnabled && triggerQuickSpinChangeRequest(!quickSpinActive)
      }
      disabled={!quickSpinEnabled}
      active={quickSpinActive}
    />
  );

  return (
    <KeypadWrapper hidden={hidden}>
      <section>
        <div>{MenuButton}</div>
        <div>{onlyAutoplay && AutoplayButton}</div>
      </section>

      <section>
        <div>
          <PaytableButton />
        </div>

        <div>
          <BetDisplayDesktopDefault />
        </div>

        <div>
          <BetButton />
        </div>

        {isFreeRoundsEnabled && (
          <div>
            <FreeRoundsDisplayDesktopDefault />
          </div>
        )}
      </section>

      <section>
        <div data-show-butterfly={showButterfly}>
          <div>{showButterfly && AutoplayButton}</div>
          <div>{SpinButton}</div>
          <div>{showButterfly && QuickSpinButton}</div>
        </div>
      </section>

      <section>
        <div>
          <WinDisplayDesktopDefault />
        </div>

        <div>
          {isFreeRoundsEnabled ? (
            <TotalWinDisplayDesktopDefault />
          ) : (
            <BalanceDisplayDesktopDefault />
          )}
        </div>
      </section>

      <section>
        <div>{onlyQuickspin && QuickSpinButton}</div>
        <div>{<SoundButton />}</div>
      </section>
    </KeypadWrapper>
  );
};
